import { Box, Container, Stack } from "@mui/material";
import React from "react";
import Divider from "../../components/divider";

export default function Statistics() {
  return (
    <div className={"static-frame"}>
      <Container>
        <Stack className="info">
          <Stack className="static-box">
            <Box className="static-num">1200+</Box>
            <Box className="static-text">Books</Box>
          </Stack>
          <Divider height="64" width="2" bg="#8B2635" />
          <Stack className="static-box">
            <Box className="static-num">340+</Box>
            <Box className="static-text">Authors</Box>
          </Stack>
          <Divider height="64" width="2" bg="#8B2635" />
          <Stack className="static-box">
            <Box className="static-num">50+</Box>
            <Box className="static-text">Genres</Box>
          </Stack>
          <Divider height="64" width="2" bg="#8B2635" />
          <Stack className="static-box">
            <Box className="static-num">5000+</Box>
            <Box className="static-text">Readers</Box>
          </Stack>
        </Stack>
      </Container>
    </div>
  );
}
